import React, { useState } from 'react';
import Modal from '../Modal';
import { CustomButton } from '../Button/Button';
import Checkbox from '../Checkbox/Checkbox';
import styles from './ConvertToAdvancedEditorDialog.module.scss';
import { useTranslation } from 'react-i18next';
import CloseButton from '../CloseButton/CloseButton';

const ConvertToAdvancedEditorDialog = ({
    open,
    onClose,
    onProceed,
    onStayInBasicEditor,
    isLoading = false,
}) => {
    const { t } = useTranslation();
    const [isSureChecked, setIsSureChecked] = useState(false);
    const [duplicateVideoChecked, setDuplicateVideoChecked] = useState(false);

    const handleProceed = () => {
        onProceed(duplicateVideoChecked);
    };

    const isProceedDisabled = !isSureChecked || isLoading;

    return (
        <Modal className={styles.modal} onClose={onClose} open={open}>
            <div className={styles.modalTitle}>
                <div className={styles.header}>
                    <div className={styles.namesContainer}>
                        <h1 tabIndex={0}>
                            {t('advanced_editor.conversion.title')}
                        </h1>
                    </div>
                    <CloseButton onClose={onClose} />
                </div>
            </div>

            <div className={styles.contentContainer}>
                <div className={styles.explanation}>
                    {t('advanced_editor.conversion.explanation')}
                </div>

                <div className={styles.checkboxes}>
                    <div className={styles.checkboxItem}>
                        <Checkbox
                            checked={duplicateVideoChecked}
                            onClick={() => setDuplicateVideoChecked(!duplicateVideoChecked)}
                            className={styles.checkbox}
                            disabled={isLoading}
                        />
                        <span className={styles.checkboxLabel}>
                            {t('advanced_editor.conversion.duplicate_video')}
                        </span>
                    </div>

                    <div className={styles.checkboxItem}>
                        <Checkbox
                            checked={isSureChecked}
                            onClick={() => setIsSureChecked(!isSureChecked)}
                            className={styles.checkbox}
                            disabled={isLoading}
                        />
                        <span className={styles.checkboxLabel}>
                            {t('advanced_editor.conversion.confirm_sure')}
                        </span>
                    </div>
                </div>
            </div>

            <div className={styles.modalActionsContainer}>
                <div className={styles.buttons}>
                    <CustomButton
                        variant="secondary"
                        label={t('advanced_editor.conversion.use_basic_editor')}
                        className={styles.cancelButton}
                        onClick={() => onStayInBasicEditor()}
                        disabled={isLoading}
                    />
                    <CustomButton
                        label={isLoading ? t('general.toast.duplicating') : t('advanced_editor.conversion.proceed')}
                        variant="primary"
                        onClick={handleProceed}
                        disabled={isProceedDisabled}
                        loading={isLoading}
                        loadingText={t('general.toast.duplicating')}
                    />
                </div>
            </div>
        </Modal>
    );
};

export default ConvertToAdvancedEditorDialog;
